<div class="card">
  <div class="card-body">
    <div class="d-flex flex-column">
      <h3>{{ label }}</h3>
      <h5 class="text-muted fw-normal">{{ total }}</h5>
    </div>
    @if (graphicType) {
      <div class="wrapper-card-charts">
        @if (graphicType === 'bar') {
          <ngx-charts-bar-vertical
            [view]="[200, 230]"
            [results]="single"
            [gradient]="gradient"
            [xAxis]="showXAxis"
            [yAxis]="showYAxis"
            [legend]="showLegend"
            [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel"
            [xAxisLabel]="xAxisLabel"
            [yAxisLabel]="yAxisLabel"
            [doughnut]="true"
            (select)="onSelect($event)"
          />
        }

        @if (graphicType === 'percentage') {
          <ngx-charts-pie-chart
            [view]="[200, 230]"
            [legend]="false"
            [labels]="false"
            [legendTitle]="''"
            [view]="[200, 230]"
            [results]="single"
            [doughnut]="true"
          />
        }
      </div>
    }

    @if (graphicType && graphicType === 'percentage') {
      <card-percentage-chart-component
        [percentage]="contactInfoChart"
        [radius]="99"
        [textColor]="textColor"
        [datasetTitle]="datasetTitle"
      />
    }

  </div>

</div>
